
// types
import { NavItemType } from 'types/menu';
import humanResource from './human-resource';
// import purchase from './purchase';
// import contact from './contacts';
import reports from './reports';
// import assets from './assets';
import project from './projects';
// import settings from './settings';
import crm from './crm';
// import attendance from "./attendance";
import settings from "./settings";
import profiles from "./profile";
import accounts from "./accounts";
// purchase,reports,contact,assets,,settings
// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [ 
    
    {
      id: 'group-main',
      // title: <FormattedMessage id="main"  />,
      // icon: icons.dashboard,
      type: 'group',
      // url: '/hr',
      children: [crm,project,humanResource,accounts,reports,profiles]}
    ,settings]
};

export default menuItems;
